import {
  hasRole,
  ROLE_ADMIN_MITRA,
  ROLE_ADMIN_PJO,
  ROLE_HSE,
} from "@/constants/mitraRole";

const BIB_COMPANY_ID = 7003;

const MITRA_ENROLLMENT_ROLES = [ROLE_ADMIN_MITRA];
const MITRA_ENROLLMENT_REPORT_ROLES = [ROLE_ADMIN_PJO, ROLE_HSE];

export function getUserRoles(profile) {
  return [
    profile?.role_id,
    ...(profile?.roles_uenroll || []),
    ...(profile?.roles_uenrol || []),
    ...(Array.isArray(profile?.roles) ? profile.roles : []),
  ].filter(Boolean);
}

export function isBibCompany(profile = {}) {
  const companyId = Number(profile.company_id || profile.companyId);
  if (companyId === BIB_COMPANY_ID) {
    return true;
  }

  const companyValues = [
    profile.company,
    profile.company_name,
    profile.companyName,
    profile.business_unit,
    profile.business_unit_name,
    profile.unit,
    typeof localStorage !== "undefined" ? localStorage.getItem("company_name") : null,
    typeof localStorage !== "undefined" ? localStorage.getItem("company") : null,
  ]
    .filter(Boolean)
    .map((value) =>
      String(value).toLowerCase().replace(/\./g, " ").replace(/\s+/g, " ").trim()
    );

  return companyValues.some(
    (value) =>
      value.includes("borneo indobara") ||
      value === "bib" ||
      value.includes("pt borneo indobara")
  );
}

export function getEnrollmentRef(event = {}) {
  const courseId =
    event.courseId ||
    event.course_id ||
    event.training_id ||
    event.trainingId ||
    event.training_course_id ||
    null;

  const trainingEventId =
    event.trainingEventId ||
    event.training_event_id ||
    event.batchId ||
    event.batch_id ||
    event.id ||
    null;

  return {
    courseId: courseId != null && courseId !== "" ? String(courseId) : null,
    trainingEventId:
      trainingEventId != null && trainingEventId !== ""
        ? String(trainingEventId)
        : null,
    courseName: event.courseName || event.course_name || event.title || "",
    learningType: event.trainingType || event.training_type || "",
  };
}

export function hasValidEnrollmentRef(event) {
  const { courseId, trainingEventId } = getEnrollmentRef(event);
  return Boolean(courseId || trainingEventId);
}

export function getEnrollmentActions(profile) {
  const roles = getUserRoles(profile);
  const actions = [];

  if (isBibCompany(profile)) {
    // BIB company employees always get both: self enrollment + enrollment report
    actions.push({
      key: "enrollment",
      label: "Enrollment",
      routeName: "idpEnrollment",
    });
    actions.push({
      key: "enrollment-report",
      label: "Enrollment Report",
      routeName: "idpEnrollmentReport",
    });
  } else {
    if (hasRole(roles, MITRA_ENROLLMENT_ROLES)) {
      actions.push({
        key: "enrollment",
        label: "View Detail Enrollment",
        routeName: "mitraEnrollment",
      });
    }
    if (hasRole(roles, MITRA_ENROLLMENT_REPORT_ROLES)) {
      actions.push({
        key: "enrollment-report",
        label: "View Enrollment Report",
        routeName: "mitraEnrollmentReport",
      });
    }
  }

  if (actions.length > 1) {
    return actions.map((action) => ({
      ...action,
      label:
        action.key === "enrollment-report" ? "Enrollment Report" : "Enrollment",
    }));
  }

  return actions;
}

export function buildEnrollmentQuery(event) {
  const { courseId, trainingEventId, courseName, learningType } =
    getEnrollmentRef(event);
  const query = {};

  if (courseId) query.course_id = courseId;
  if (trainingEventId) query.training_event_id = trainingEventId;
  if (courseName) query.search = courseName;
  if (learningType) query.learning_type = learningType;

  return query;
}
